/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Projects_Bulk_Tag_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to tag {count} project(s)" |
*
* @param {Projects_Bulk_Tag_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_bulk_tag_error = /** @type {((inputs: Projects_Bulk_Tag_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Bulk_Tag_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tag konnte nicht auf ${i?.count} Projekt(e) angewendet werden`)
	return /** @type {LocalizedString} */ (`Failed to tag ${i?.count} project(s)`)
});